import { cn } from '#/lib/utils'

type TagPillProps = {
  label: string
  active?: boolean
  onClick?: () => void
  className?: string
}

export default function TagPill({
  label,
  active = false,
  onClick,
  className,
}: TagPillProps) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={cn(
        'rounded-full border cursor-pointer px-4 py-2 text-[12px] font-semibold  tracking-[0.04em] transition-all',
        'border-secondary-200  text-secondary-800',
        'hover:border-secondary-300 hover:bg-secondary-100 hover:text-neutral-900',
        active &&
          'border-secondary-700 bg-secondary-500 text-secondary-50 hover:bg-secondary-500 hover:text-white',
        className,
      )}
    >
      {label}
    </button>
  )
}
